import { trpc } from '../lib/trpc';
import { Wizard } from './CreateWizard';
import { Button, Table } from '@mantine/core';
import { modals } from '@mantine/modals';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { type FC } from 'react';
import { ulid } from 'ulid';
import { useLocation } from 'wouter';

dayjs.extend(localizedFormat);

export const Components: FC = () => {
  const [, navigate] = useLocation();
  const componentsQuery = trpc.components.list.useQuery();

  return (
    <div className="w-full p-5">
      <Button
        onClick={() => {
          const modalId = ulid();
          modals.open({
            children: <Wizard modalId={modalId} />,
            modalId,
            size: 'xl',
            title: <strong>Create component</strong>,
          });
        }}
      >
        Add
      </Button>
      <Table
        highlightOnHover
        striped
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Fields</Table.Th>
            <Table.Th>Updated</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {componentsQuery.data?.map((row) => (
            <Table.Tr
              className="cursor-pointer"
              key={row.id}
              onClick={() => navigate(`/components/${row.id}`)}
            >
              <Table.Td>{row.name}</Table.Td>
              <Table.Td>{row.schema?.fields.length || 0}</Table.Td>
              <Table.Td>{dayjs(row.updatedAt).format('L LT')}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
};
